/** Empty search state. Says so when the proxy is on its small built-in test set (no Spotify keys). */
export function NoMatches({ q, fixture, style }: { q: string; fixture?: boolean; style?: React.CSSProperties }) {
  return (
    <p className="muted" style={{ fontSize: 15, ...style }}>
      No artists match “{q.trim()}”
      {fixture ? (
        <>
          {' '}
          in the test data. This server has no Spotify keys yet, so search covers only a few built-in artists (try Radiohead).
        </>
      ) : (
        '.'
      )}
    </p>
  );
}
